export default __webpack_public_path__ + "static/media/facebook-button.a0c31d4b.png";